(function () {
  if (window.__localPartsFreeShippingLoaded) return;
  window.__localPartsFreeShippingLoaded = true;

  const selector = '[data-lp-free-shipping]';
  const moneyFormatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  });

  function formatMoney(cents) {
    return moneyFormatter.format(Math.max(0, cents) / 100);
  }

  function updateBars(total) {
    document.querySelectorAll(selector).forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 7900);
      const clampedTotal = Math.max(0, Number(total || 0));
      const remaining = Math.max(0, threshold - clampedTotal);
      const progressRaw = threshold > 0 ? (clampedTotal / threshold) * 100 : 0;
      const progress = Math.min(100, Math.max(0, Math.round(progressRaw)));
      const progressScale = String(Math.min(1, Math.max(0, progressRaw / 100)));
      const progressWidth = `${Math.min(100, Math.max(0, progressRaw)).toFixed(2)}%`;
      const message = bar.querySelector('[data-lp-free-shipping-message]');
      const fill = bar.querySelector('[data-lp-free-shipping-fill]');
      const current = bar.querySelector('[data-lp-free-shipping-current]');
      const percent = bar.querySelector('[data-lp-free-shipping-percent]');
      const progressbar = bar.querySelector('[data-lp-free-shipping-progressbar]');

      bar.dataset.cartTotal = String(clampedTotal);
      bar.classList.toggle('lp-free-shipping--complete', remaining === 0);

      if (message) {
        message.textContent =
          remaining > 0
            ? `You are only ${formatMoney(remaining)} away from Free Shipping!`
            : "Congratulations! You've unlocked Free Shipping!";
      }

      if (fill) {
        fill.style.setProperty('--lp-progress-scale', progressScale);
        fill.style.setProperty('--lp-progress-width', progressWidth);
        fill.style.setProperty('width', progressWidth, 'important');
        fill.style.setProperty('background', 'linear-gradient(90deg, #dff9ff 0%, #68dfff 48%, #249bff 100%)', 'important');
        fill.style.setProperty('transform', 'none', 'important');
      }
      if (progressbar) {
        progressbar.style.setProperty('--lp-progress-width', progressWidth);
      }
      if (current) current.textContent = formatMoney(clampedTotal);
      if (percent) percent.textContent = `${progress}%`;
      if (progressbar) progressbar.setAttribute('aria-valuenow', String(clampedTotal));
    });
  }

  function refreshBars() {
    if (!document.querySelector(selector)) return;

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart && typeof cart.total_price === 'number') updateBars(cart.total_price);
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', refreshBars);
  document.addEventListener('cart:updated', refreshBars);

  const nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function () {
      const request = arguments[0];
      const url = typeof request === 'string' ? request : request && request.url;
      const isCartMutation =
        typeof url === 'string' &&
        (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'));

      return nativeFetch.apply(this, arguments).then((response) => {
        if (isCartMutation) window.setTimeout(refreshBars, 250);
        return response;
      });
    };
  }
})();
